/**
 * Navigation utility for API service and other non-React contexts
 * This allows us to programmatically navigate from outside React components
 */

let navigateFunction: ((path: string) => void) | null = null;

export const setNavigateFunction = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
};

export const getNavigateFunction = () => navigateFunction;

export const navigateTo = (path: string) => {
  if (navigateFunction) {
    try {
      navigateFunction(path);
    } catch (error) {
      console.warn('Navigate function failed, using window.location:', error);
      // Always fallback to window.location for critical navigation
      window.location.href = path;
    }
  } else {
    console.warn('Navigate function not set. Using window.location for:', path);
    // Always fallback to window.location when navigate function is not available
    window.location.href = path;
  }
};
